export const CART_CONSTANTS = {
    GET_CART_ITEMS : 'GET_CART_ITEMS',
    SET_CART_ITEMS : 'SET_CART_ITEMS',
    DEL_CART_ITEMS : 'DEL_CART_ITEMS',
    GET_CART_COUNT : 'GET_CART_COUNT',
    SET_CART_COUNT : 'SET_CART_COUNT',
}